<template>
  <div>
    <jczh-table-content
      ref="multipleTable"
      :data="listData"
      :option="listOptions"
      @sort-change="sortChange"
    >
      <template v-slot:last>
        <el-table-column label="操作" align="center" width="160" fixed="right">
          <template slot-scope="{ row }">
            <template v-for="item in operateOptions">
              <el-button
                v-if="hasPermission(row.orderStatus, item.functionType)"
                :key="item.functionType"
                type="text"
                :class="item.buttonClass"
                @click="handleOperate(item.functionType, row)"
              >
                {{ item.buttonText }}
              </el-button>
            </template>
          </template>
        </el-table-column>
      </template>
    </jczh-table-content>
    <pagination
      v-show="total > 0"
      ref="pagination"
      :total="total"
      :page.sync="page"
      :limit.sync="size"
    />
  </div>
</template>
<script>
import Pagination from '@/components/common/Pagination'
// 数据字典
import {
  inquiryWayDict,
  inquiryStatusDict,
  inquiryFlowStatusDict
} from '@/dictionary/project/inquiry'
import { projectTypeDict, whetherDict } from '@/dictionary/project/common'
// 后端接口
import { getInquiryListApi, removeInquiryApi } from '@/api/procure/inquiry'
import { mapState } from 'vuex'
import { workbenchServiceDict } from '@/dictionary/system'
export default {
  components: {
    Pagination
  },

  props: {
    filterForm: {
      type: Object,
      default: () => {}
    },

    fetchApi: {
      type: Function,
      default: getInquiryListApi
    },

    // 是否是委托项目, 委托项目列表新增三项：项目名称、委托方、负责人
    isEntrust: {
      type: Boolean,
      default: false
    },

    pageNum: {
      type: [String, Number],
      default: 1
    },

    pageSize: {
      type: [String, Number],
      default: 10
    },

    isTableGreyFeatures: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      total: 0,
      listData: [],
      // page: 1,
      // size: 10,
      operateOptions: [
        {
          buttonText: '编辑',
          functionType: 'edit',
          buttonClass: 'primary-button'
        },
        {
          buttonText: '删除',
          functionType: 'remove',
          buttonClass: 'danger-button'
        },
        {
          buttonText: '复制项目',
          functionType: 'copy',
          buttonClass: 'primary-button'
        },
        {
          buttonText: '查看详情',
          functionType: 'look',
          buttonClass: 'info-button'
        }
      ]
    }
  },

  computed: {
    ...mapState('router', ['currentWorkbench']),

    page: {
      get() {
        return this.pageNum
      },
      set(val) {
        this.$emit('update:pageNum', val)
      }
    },

    size: {
      get() {
        return this.pageSize
      },
      set(val) {
        this.$emit('update:pageSize', val)
      }
    },

    listOptions() {
      const common = [
        {
          label: '询比单名称',
          prop: 'orderName',
          minWidth: 150
        },
        {
          label: '询比单编号',
          prop: 'orderCode',
          minWidth: 150
        },
        {
          label: '项目类型',
          prop: 'projectType',
          minWidth: 150,
          filter: value => projectTypeDict.translate(value).label || ' - '
        },
        {
          label: '询比方式',
          prop: 'inquiryType',
          minWidth: 100,
          filter: value => inquiryWayDict.translate(value).label
        },
        {
          label: '发布日期',
          prop: 'publishTime',
          columnAttrs: {
            sortable: 'custom',
            prop: 'publishTime'
          },
          minWidth: 160,
          isNormDay: true
        },
        {
          label: '报价截止时间',
          prop: 'offerEndTime',
          columnAttrs: {
            prop: 'offerEndTime',
            sortable: 'custom'
          },
          minWidth: 160,
          isNormMinute: true
        },
        {
          label: '询比状态',
          prop: 'orderStatus',
          minWidth: 100,
          useTag: true,
          tagDict: inquiryFlowStatusDict
        },
        {
          label: '收到的报价',
          prop: 'offerCount',
          minWidth: 100,
          filter: value => `共 ${value === ' - ' ? 0 : value} 条报价`
        },
        {
          label: '线上评审',
          prop: 'isOnlineReview',
          minWidth: 80,
          filter: value => whetherDict.translate(value).label || '-'
        },
      ]
      const entrustItem = [
        {
          label: '项目名称',
          prop: 'entrustProjectName',
          minWidth: 150
        },
        {
          label: '委托方',
          prop: 'entrustPurchaseCompanyName',
          minWidth: 150
        },
        {
          label: '负责人',
          prop: 'entrustUserName',
          minWidth: 150
        }
      ]
      return this.isEntrust ? [...entrustItem, ...common] : common
    },

    hasPermission() {
      return (status, buttonType) => {
        // 五菱去除项目复制
        if (this.isTableGreyFeatures && buttonType == 'copy') {
          return false
        }
        if (!inquiryFlowStatusDict.translate(status).permission) return false

        const operateList = inquiryFlowStatusDict.translate(status).permission
        return operateList.includes(buttonType)
      }
    },

    // 代理机构加上Agency
    entrustRouter() {
      if (this.currentWorkbench === workbenchServiceDict.AGENCY.value) {
        return 'Agency'
      }
      return ''
    },

    // 委托项目id
    projectId() {
      return this.$route.params.projectId || ''
    }
  },

  activated() {
    this.getList()
  },

  methods: {
    // 获取列表
    getList() {
      const requestParams = Object.assign(
        {},
        {
          page: this.page,
          size: this.size
        },
        this.filterForm
      )
      this.fetchApi(requestParams)
        .then(res => {
          this.listData = res?.data?.records || []
          this.total = res?.data?.total || 0

          // 如果当前页没数据且总数据量大于0，则要页码-1后重新发起请求
          if (res.data.records.length === 0 && res.data.total > 0) {
            this.$refs.pagination.handleCurrentChange(this.page--)
          }
        })
        .catch(err => {
          this.$message.error(err?.message || '获取询比列表失败')
        })
    },

    // 处理操作，执行相应的方法
    handleOperate(functionType, row) {
      this[functionType](row)
    },

    //  编辑
    edit(row) {
      this.$router.push({
        name: this.entrustRouter + 'InquiryForm',
        params: { orderId: row.orderId, projectId: row.projectId }
      })
    },

    //  删除
    async remove(row) {
      const { orderId } = row
      try {
        if (!(await this.$systemConfirm('DELETE_INQUIRY_ORDER'))) return
        const res = await removeInquiryApi({ orderId })
        this.$message.success(res.message || '删除成功')
        this.getList()
      } catch (err) {
        this.$message.error(err.message || '删除失败')
      }
    },

    //  查看详情
    look(row) {
      let routerName = ''
      // 有审批流取审批流的流程
      if (row.orderFlowStatus) {
        routerName = inquiryFlowStatusDict.translate(row.orderFlowStatus)
          .routerName
      } else {
        routerName = inquiryFlowStatusDict.translate(row.orderStatus).routerName
      }
      this.$router.push({
        name: this.entrustRouter + routerName,
        params: {
          orderId: row.orderId,
          orderName: row.orderName,
          projectId: row.projectId
        }
      })
    },

    // 复制
    async copy(row) {
      this.$confirm(`复制 “${row.orderName}” 的询比信息`, '复制项目', {
        confirmButtonText: '确定复制',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$router.push({
          name: this.entrustRouter + 'InquiryForm',
          params: {
            orderId: row.orderId,
            projectId: row.projectId,
            isCopy: true
          }
        })
      })
    },

    /**
     * 按顺序排序
     */
    sortChange(column, prop, order) {
      this.filterForm.sortBy = column.prop
        .replace(/([A-Z])/g, '_$1')
        .toLowerCase()
      if (column.order == 'ascending') {
        this.filterForm.sortType = 'asc'
      } else if (column.order == 'descending') {
        this.filterForm.sortType = 'desc'
      } else {
        this.filterForm.sortType = undefined
      }
      this.getList()
    },

    /**
     * 清除排序
     */
    clearSort() {
      this.$refs.multipleTable?.$refs.table.clearSort()
    }
  }
}
</script>
